export const APPEALS_OPTIONS_TABLE = [
  "dealer.dealerName",
  "dealer.inn",
  "dealer.code",
  "year",
  "quarter",
  "contactPersonFio",
  "dealer.headNameImported",
  "malusStatusFrontend",
  "appealStatusFrontend",
  "resolutionStatusFrontend",
] as const;
